<div>
  <section class="Flexbox filters" *ngIf="filters">
    <dls-tabs>
      <a (click)="notesFilter = 'all'" [ngClass]="{'pt-selected':notesFilter == 'all'}" class="{{cssClassFormat('all')}}">
        <span>{{'ALL_NOTES'}}</span>
      </a>
      <a (click)="notesFilter = 'my'" [ngClass]="{'pt-selected':notesFilter == 'my'}" class="{{cssClassFormat('my')}}">
        <span>{{'MY_NOTES'}}</span>
      </a>
      <a (click)="notesFilter = 'others'" [ngClass]="{'pt-selected':notesFilter == 'others'}" class="{{cssClassFormat('others')}}">
        <span>{{'OTHER_NOTES'}}</span>
      </a>
    </dls-tabs>
  </section>
  <ul class="notes" id="notes-list" *ngIf="load" scroll-glue>
    <li *ngFor="let currentNote of notes" class="note" [ngClass]="{'my':currentNote.actor.id == actorId}">
      <gen-user-profile
        class="note-user-profile"
        layout="USER_WITH_DATE_TWO_LINES"
        [name]="currentNote.actor.name[0].text"
        [picUrl]="getAvatarImage(currentNote)"
        [date]="currentNote.meta.lastUpdated |date:'dd MMM y HH:mm'">
      </gen-user-profile>
      <span class="new-note" *ngIf="!currentNote.read">New</span>
      <div class="note-content">
        <span [ngSwitch]="currentNote.action">
          <div class="note-action note-action-approved" *ngSwitchCase="'approved'">
            <div class="note-action note-label">Approved</div>
          </div>
          <div class="note-action note-action-rejected" *ngSwitchCase="'rejected'">
            <div class="note-action note-label">Rejected</div>
          </div>
           <div class="note-action note-action-rejected" *ngSwitchCase="'archived'">
            <div class="note-action note-label">Archived</div>
          </div>
        </span>
        <div class="note-text ql-editor" [innerHTML]="currentNote.text" genReadMore [maxHeight]="80"></div>
      </div>
    </li>
  </ul>
  <gen-overlay-loader class="loader" *ngIf="!load" [showOverlay]="false"></gen-overlay-loader>

  <form *ngIf="!readOnly" class="note-input" (ngSubmit)="postNote()" tabindex=0
        genPermissionSchemaRestrict [permissionSchemaKey]="'noteWrite'" [nonePermissionAction]="'hide'"
        [nonePermissionOnHideMsg]="'You do not have permissions to add a new note'"
        [nonePermissionOnHideMsgClass]="'Flexbox Flexbox__just-center Flexbox__box-direction-column attachments-sub-header'">

    <p-editor placeholder="{{'Enter your note' | translate}}" name="firstName" [(ngModel)]="note.text" (onTextChange)="checkNote($event)">
      <p-header>
       <span class="ql-formats">
         <button class="ql-bold" aria-label="Bold"></button>
         <button class="ql-italic" aria-label="Italic"></button>
         <button class="ql-underline" aria-label="Underline"></button>
         <select class="ql-size">
          </select>
          <button class="ql-list" value="ordered" aria-label="Ordered List"></button>
          <button class="ql-list" value="bullet" aria-label="Unordered  List"></button>
         <select class="ql-align">
          </select>
        </span>
      </p-header>
    </p-editor>
    <div class="note-input-options Flexbox Flexbox_rows Flexbox__just-end">
      <div class="note-actions">
        <input type="submit" class="btn btn-primary" value="{{'Add note' | translate}}"
               [disabled]="!load || !note.text || noteLength == 0"/>
      </div>
    </div>
  </form>

</div>
